/*
 Copyright (c), CKSource Holding sp. z o.o. All rights reserved.
 */

import { IDescriptorBody } from '../../../descriptor';
import PackageDataMessage, { IPackageDataMessage } from './packagedatamessage';

import ParserUtils, { MessageDataTypes } from './../parserutils';

export interface IBytesBytesPacketDataMessage extends IPackageDataMessage {
	data: Buffer;
	data1: Buffer;
}

export default class BytesBytesPacketDataMessage extends PackageDataMessage {
	public static readonly TYPE: number =
		/* #__PURE__ -- @preserve */ ( () => ParserUtils.getPacketType( MessageDataTypes.BUFFER, MessageDataTypes.BUFFER ) )();

	public static readonly DESCRIPTOR_NAME: string = 'BytesBytesPacketDataMessage';

	public static readonly DESCRIPTOR: IDescriptorBody = /* #__PURE__ -- @preserve */ ( () => ( {
		fields: {
			data: {
				type: 'bytes',
				id: 1
			},
			data1: {
				type: 'bytes',
				id: 2
			}
		}
	} ) )();

	public constructor( public readonly data: Buffer, public readonly data1: Buffer ) {
		super();
	}

	public toJSON(): IBytesBytesPacketDataMessage {
		return {
			data: this.data,
			data1: this.data1
		};
	}

	public static fromJSON( data: IBytesBytesPacketDataMessage ): BytesBytesPacketDataMessage {
		return new BytesBytesPacketDataMessage( data.data, data.data1 );
	}

	public static create( data: Buffer, data1: Buffer ): BytesBytesPacketDataMessage {
		return new BytesBytesPacketDataMessage( data, data1 );
	}
}
